import { useEffect } from 'react';

const ABOUT_HERO_IMAGE = 'https://static.readdy.ai/image/2d29664032ce3429a58840abfd6f4538/67489f822696851436818a0b435b69cd.png';

export default function AboutHeroSection() {
  useEffect(() => {
    document.title = 'About | MANDIE OZEE.';
  }, []);

  return (
    <section className="relative bg-[#FDFAF8] min-h-[60vh] md:min-h-[80vh] flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src={ABOUT_HERO_IMAGE}
          alt="Mandie Ozee, Clinical Psychologist, Therapist, Transformation Coach"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/30 z-[1]" />
      </div>

      <div className="relative z-[2] w-full px-4 md:px-8 lg:px-12 py-24 md:py-32">
        <div className="max-w-4xl mx-auto text-center">
          {/* Eyebrow */}
          <p className="text-[#D4AF37] text-xs font-body tracking-[0.25em] uppercase mb-6 [text-shadow:0_1px_4px_rgba(0,0,0,0.4)]">
            Clinical Psychologist · Therapist · Transformation Coach
          </p>

          {/* Headline */}
          <h1 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] leading-tight [text-shadow:0_2px_8px_rgba(0,0,0,0.5)]">
    I didn't come to teach you how to cope.
    <br />
    I came to bring you back to yourself.
          </h1>
        </div>
      </div>
    </section>
  );
}